import React from 'react';
import styled from 'styled-components';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PageContainer = styled.div`
  padding-top: var(--header-h);
  min-height: 100vh;
  background: white;
  width: 100%;
`;

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px 60px;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  color: #333;
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 30px;
  transition: color 0.3s ease;

  &:hover {
    color: #666;
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 30px;
  font-weight: 300;
`;

const Content = styled.div`
  background: white;
  border-radius: 15px;
  padding: 40px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e0e0e0;
  line-height: 1.8;
  color: #333;

  h2 {
    font-size: 1.8rem;
    color: #333;
    margin-top: 30px;
    margin-bottom: 15px;
    font-weight: 600;
  }

  h3 {
    font-size: 1.3rem;
    color: #333;
    margin-top: 25px;
    margin-bottom: 12px;
    font-weight: 600;
  }

  p {
    margin-bottom: 15px;
    font-size: 1rem;
  }

  ul {
    margin-left: 20px;
    margin-bottom: 15px;
  }

  li {
    margin-bottom: 8px;
  }
`;

const MesafeliSatisPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <Container>
        <BackButton onClick={() => navigate(-1)}>
          <ArrowLeft size={20} />
          Geri Dön
        </BackButton>

        <Title>Mesafeli Satış Sözleşmesi</Title>

        <Content>
          <h2>1. Taraflar</h2>
          <p>
            <strong>Satıcı:</strong> Saraylı Moda<br />
            <strong>Adres:</strong> İstanbul, Türkiye<br />
            <strong>Telefon:</strong> 0224 221 51 20<br />
            <strong>E-posta:</strong> info@saraylimoda.com
          </p>

          <h2>2. Konu</h2>
          <p>
            Bu sözleşme, Saraylı Moda'nın internet sitesi üzerinden satışa sunduğu ürünlerin 
            satışı ve teslimi ile ilgili tarafların hak ve yükümlülüklerini düzenlemektedir.
          </p>

          <h2>3. Sipariş ve Ödeme</h2>
          <p>
            Siparişleriniz, web sitemiz üzerinden alınır. Ödeme, güvenli ödeme sistemleri 
            (PayTR, İyzico) üzerinden gerçekleştirilir.
          </p>

          <h2>4. Teslimat</h2>
          <p>
            Ürünler, sipariş formunda belirtilen adrese teslim edilir. Standart teslimat süresi 
            3-7 iş günüdür. Özel üretim ürünler için teslimat süresi 4-6 hafta arasında değişebilir.
          </p>

          <h2>5. Cayma Hakkı</h2>
          <p>
            Mesafeli satış sözleşmelerinden cayma hakkınız bulunmaktadır. Ürünü teslimat tarihinden 
            itibaren 14 gün içinde iade edebilirsiniz.
          </p>

          <h2>6. İade Koşulları</h2>
          <ul>
            <li>Ürün orijinal ambalajında ve etiketleriyle birlikte olmalıdır</li>
            <li>Ürün kullanılmamış, yıkanmamış ve hasar görmemiş olmalıdır</li>
            <li>Özel üretim ürünlerde iade kabul edilmemektedir</li>
          </ul>

          <h2>7. Uyuşmazlıkların Çözümü</h2>
          <p>
            Bu sözleşmeden doğan uyuşmazlıkların çözümünde Türkiye Cumhuriyeti yasaları uygulanır. 
            İstanbul Mahkemeleri yetkilidir.
          </p>

          <h2>8. İletişim</h2>
          <p>
            Sorularınız için bizimle iletişime geçebilirsiniz:
          </p>
          <p>
            <strong>E-posta:</strong> info@saraylimoda.com<br />
            <strong>Telefon:</strong> 0224 221 51 20
          </p>
        </Content>
      </Container>
    </PageContainer>
  );
};

export default MesafeliSatisPage;

